import { IconBrandInstagram, IconBrandTwitter, IconBrandYoutube } from '@tabler/icons-react';
import {
  ActionIcon,
  Box,
  Container,
  Group,
  Image,
  Text,
  useMantineColorScheme,
} from '@mantine/core';
import { useScreenLargerThan } from '@/hooks/useScreenLargerThan';
import { getLogoSvg } from '../Logo/LogoSvg';

type FooterProps = {
  style?: React.CSSProperties;
};

export function Footer({ style }: FooterProps) {
  const logoSvg = getLogoSvg();
  const screenLargerThanMd = useScreenLargerThan('sm');
  const { colorScheme } = useMantineColorScheme();

  return (
    <Box p="xl" bg={colorScheme === 'dark' ? '#191919' : '#F8F7F7'} style={style}>
      <Container size="xl">
        <Group justify={screenLargerThanMd ? 'space-between' : 'center'}>
          <Image
            w={185}
            src={logoSvg}
            alt="Brasil Arena: clique para ir para a página inicial"
            title="Ir para a página inicial da Brasil Arena"
          />

          <Text c="dimmed" fz="sm">
            Copyright © {new Date().getFullYear()} Brasil Arena. Todos direitos reservados.
          </Text>

          <Group gap={0} justify="flex-end" wrap="nowrap">
            <ActionIcon size="xl" color="gray" variant="subtle">
              <IconBrandTwitter size={22} />
            </ActionIcon>
            <ActionIcon size="xl" color="gray" variant="subtle">
              <IconBrandYoutube size={22} />
            </ActionIcon>
            <ActionIcon size="xl" color="gray" variant="subtle">
              <IconBrandInstagram size={22} />
            </ActionIcon>
          </Group>
        </Group>
      </Container>
    </Box>
  );
}
